module.exports = __webpack_public_path__ + "static/media/portfolio-img7.619b4492.jpg";